import { initializeApp } from 'firebase/app'
import { getStorage } from 'firebase/storage'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'

// Replace with your Firebase project config
// You can find this in Firebase Console > Project Settings > General
const firebaseConfig = {
  apiKey: "AIzaSyAs0X4MsMInipKmLHpcpAxbn_fLN4TJIHc",
  authDomain: "geez-sirate-kidase.firebaseapp.com",
  projectId: "geez-sirate-kidase",
  storageBucket: "geez-sirate-kidase.appspot.com",
  messagingSenderId: "894513832139",
  appId: "1:894513832139:web:d8c104ece6c09fcd127b4e",
  measurementId: "G-P90HW9D4B1"
}

const app = initializeApp(firebaseConfig)
export const storage = getStorage(app)
export const auth = getAuth(app)
export const db = getFirestore(app)
export const functions = getFunctions(app)
export default app
